import { render } from "./FullCredits.vue?vue&type=template&id=c6945568&scoped=true"
import script from "./FullCredits.vue?vue&type=script&lang=js"
export * from "./FullCredits.vue?vue&type=script&lang=js"

import "./FullCredits.vue?vue&type=style&index=0&id=c6945568&lang=less&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6945568"]])

export default __exports__